import { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import cogoToast from 'cogo-toast';

import { getRegistrationCodes } from '../../../api/registration_codes';

const ConciergeCodesModalData = props => {
  const { setIsLoading, setRegistrationCodes, searchVal } = props;
  const loadCodesTimeoutRef = useRef(null);

  const fetchRegistrationCodes = async searchTerm => {
    try {
      const params = {
        limit: 100
      };

      if (searchTerm) params.searchTerm = searchTerm;

      const response = await getRegistrationCodes(params);
      setRegistrationCodes(response.codes || []);
    } catch (e) {
      cogoToast.error(e);
    } finally {
      setIsLoading(false);
    }
  };

  const debounceLoadRegistrationCodes = async searchTerm => {
    setIsLoading(true);
    if (loadCodesTimeoutRef.current) {
      clearTimeout(loadCodesTimeoutRef.current);
    }

    loadCodesTimeoutRef.current = setTimeout(() => {
      fetchRegistrationCodes(searchTerm);
    }, 500);
  };

  useEffect(() => {
    debounceLoadRegistrationCodes(searchVal);

    return () => {
      if (loadCodesTimeoutRef.current) {
        clearTimeout(loadCodesTimeoutRef.current);
      }
    };
  }, [searchVal]);

  return null;
};

ConciergeCodesModalData.propTypes = {
  setIsLoading: PropTypes.func.isRequired,
  setRegistrationCodes: PropTypes.func.isRequired,
  searchVal: PropTypes.string.isRequired
};

export default ConciergeCodesModalData;
